var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTheoremeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 186,
    height: 124,
    viewBox: "0 0 186 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_68814)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.612 166.225L163.898 94.5144C166.735 80.2781 157.603 66.9363 143.674 65.2975L137.38 64.5567C135.12 64.2905 132.911 63.7099 130.809 62.8287L118.275 57.5719L66.6992 35.9428L53.1172 30.2468C50.7966 29.2739 48.6117 27.9919 46.6204 26.4348L41.0194 22.0542C28.3226 12.1244 9.63269 14.6385 0.227122 27.7693L-48.2279 95.419C-56.3309 106.732 -54.2657 121.685 -43.5078 130.267C-31.5403 139.812 -13.289 137.511 -3.80502 125.467L10.9217 106.768C13.9766 102.889 19.2773 101.379 23.8554 103.067L100.57 131.352C104.718 132.881 107.143 137.048 106.515 141.535L103.51 162.986C101.597 176.648 111.648 187.888 125.107 187.413C136.861 186.997 147.274 177.958 149.611 166.225L149.612 166.225Z",
    fill: "url(#paint0_linear_106_68814)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M103.168 92.1727L60.7558 75.6578C56.9798 74.1878 55.3943 69.4585 57.2325 65.1016L69.0999 36.9721L124.163 60.0411L112.757 87.0785C110.99 91.2658 106.704 93.5495 103.168 92.172L103.168 92.1727Z",
    fill: "url(#paint1_linear_106_68814)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M113.762 163.017C115.707 158.038 119.122 156.491 121.796 148.755C123.046 145.139 126.6 134.858 122.161 126.971C117.909 119.415 108.361 117.679 96.0123 115.435C80.1005 112.543 79.1945 116.264 68.3916 113.365C52.6423 109.138 50.2204 100.063 37.8947 98.9854C31.7496 98.4479 26.1613 100.165 21.5254 102.495C22.3132 102.602 23.0954 102.787 23.8569 103.068L100.572 131.352C104.72 132.882 107.144 137.048 106.516 141.535L103.512 162.987C101.959 174.072 108.285 183.563 117.917 186.494C111.624 175.043 111.91 167.761 113.762 163.018L113.762 163.017Z",
    fill: "url(#paint2_linear_106_68814)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49.835 61.7741C44.6771 73.9999 30.3531 80.0158 17.6707 75.1442C4.7952 70.1989 -1.48928 55.9491 3.8117 43.3842C9.11268 30.8192 23.8734 24.9797 36.6052 30.2656C49.1461 35.4727 54.9937 49.5486 49.8358 61.7744L49.835 61.7741Z",
    fill: "url(#paint3_linear_106_68814)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0936 101.644C58.9245 111.526 47.4329 116.568 37.3157 112.865C27.0745 109.116 22.1352 97.8537 26.3971 87.7515C30.6591 77.6494 42.432 72.7143 52.5797 76.6841C62.6045 80.6064 67.2628 91.7617 63.0936 101.644Z",
    fill: "url(#paint4_linear_106_68814)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5972 100.32C56.2315 108.298 46.9531 112.35 38.8006 109.347C30.5684 106.314 26.6119 97.2495 30.0376 89.1295C33.4632 81.0096 42.9247 77.0253 51.0966 80.2016C59.1888 83.3478 62.9626 92.3428 59.5972 100.32Z",
    fill: "url(#paint5_linear_106_68814)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6738 99.2766C54.3293 104.834 47.8676 107.668 42.1779 105.586C36.4188 103.479 33.6415 97.1457 36.0382 91.4648C38.4349 85.784 45.0546 83.0091 50.7612 85.2413C56.398 87.4467 59.018 93.7202 56.6738 99.2766Z",
    fill: "url(#paint6_linear_106_68814)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7078 98.5318C52.8153 103.018 47.5978 105.297 43.0132 103.608C38.3842 101.902 36.1592 96.8053 38.0855 92.2396C40.0117 87.6739 45.3325 85.4326 49.9274 87.2194C54.4775 88.9881 56.5999 94.0468 54.7075 98.5326L54.7078 98.5318Z",
    fill: "url(#paint7_linear_106_68814)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.231 121.883C113.214 131.404 102.427 136.367 93.0389 132.931C83.5405 129.454 79.0845 118.72 83.1878 108.994C87.2911 99.2684 98.3289 94.4009 107.741 98.0829C117.042 101.722 121.248 112.36 117.231 121.883Z",
    fill: "url(#paint8_linear_106_68814)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.984 120.653C110.741 128.339 102.032 132.33 94.4683 129.542C86.8323 126.729 83.2634 118.09 86.5619 110.271C89.8605 102.453 98.7316 98.5239 106.311 101.471C113.82 104.39 117.227 112.966 113.984 120.653Z",
    fill: "url(#paint9_linear_106_68814)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M112.776 120.294C110.431 125.851 103.969 128.685 98.2797 126.603C92.5213 124.496 89.7433 118.163 92.14 112.482C94.5367 106.801 101.156 104.026 106.863 106.258C112.5 108.464 115.12 114.737 112.776 120.294Z",
    fill: "url(#paint10_linear_106_68814)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110.809 119.549C108.916 124.035 103.699 126.315 99.114 124.625C94.4848 122.92 92.2601 117.823 94.1863 113.257C96.1125 108.691 101.433 106.451 106.028 108.237C110.578 110.005 112.701 115.063 110.808 119.55L110.809 119.549Z",
    fill: "url(#paint11_linear_106_68814)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4814 48.405C53.9355 47.7728 53.2051 46.0141 53.853 44.4784L55.9151 39.5906C56.563 38.0549 58.3405 37.3315 59.8823 37.9733C61.4219 38.6141 62.1434 40.3734 61.4976 41.9039L59.4427 46.7747C58.797 48.3052 57.0246 49.0351 55.4817 48.4042L55.4814 48.405Z",
    fill: "url(#paint12_linear_106_68814)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123.466 76.1228C122.056 75.5464 121.413 73.8901 122.032 72.4232L124.001 67.7568C124.62 66.2907 126.262 65.5767 127.668 66.1628C129.071 66.7469 129.707 68.4047 129.09 69.8664L127.128 74.5173C126.512 75.9789 124.873 76.698 123.466 76.1221L123.466 76.1228Z",
    fill: "url(#paint13_linear_106_68814)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3907 37.4592L31.5771 35.4817C30.1587 34.899 28.5318 35.5506 27.946 36.939L25.644 42.3955C25.4353 42.8901 25.3811 43.4342 25.4881 43.96L26.3186 48.0453C26.5004 48.9376 27.1268 49.6816 27.9883 50.0276L28.4678 50.2204C29.3278 50.5657 30.3061 50.4673 31.0762 49.9592L34.5876 47.6401C35.0376 47.3424 35.3887 46.9218 35.5961 46.4302L37.8844 41.0062C38.4667 39.626 37.7989 38.0394 36.3904 37.46L36.3907 37.4592Z",
    fill: "url(#paint14_linear_106_68814)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7128 69.8798L17.8599 67.9955C16.4299 67.4402 15.7429 65.8638 16.3287 64.4754L18.6307 59.0189C18.8394 58.5243 19.1938 58.0999 19.6494 57.7993L23.1902 55.4604C23.964 54.9495 24.9468 54.8486 25.8092 55.1924L26.2894 55.3836C27.1507 55.726 27.7757 56.4651 27.9565 57.3535L28.7804 61.4047C28.8856 61.9244 28.8318 62.4635 28.6243 62.9551L26.3361 68.379C25.7538 69.7593 24.1329 70.4318 22.7125 69.8805L22.7128 69.8798Z",
    fill: "url(#paint15_linear_106_68814)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3317 43.6076L9.323 48.3688C8.7332 49.7668 9.42914 51.3653 10.8754 51.9379L16.5358 54.1803C17.047 54.3829 17.6079 54.4346 18.1493 54.3298L22.3514 53.512C23.2684 53.3336 24.0327 52.7211 24.3876 51.8799L24.5854 51.4112C24.9402 50.57 24.8388 49.6113 24.3151 48.8574L21.9158 45.402C21.6072 44.9569 21.1699 44.6102 20.66 44.4047L15.0133 42.1297C13.5708 41.5482 11.9215 42.2096 11.3317 43.6076Z",
    fill: "url(#paint16_linear_106_68814)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6043 56.9567L42.635 61.6246C42.0568 62.9952 40.458 63.6587 39.0612 63.1052L33.5504 60.9216C33.0489 60.7231 32.6197 60.3841 32.3167 59.9466L29.9486 56.5349C29.4293 55.7872 29.3295 54.8327 29.6832 53.9945L29.8803 53.5273C30.2339 52.6891 30.9941 52.0782 31.9036 51.9011L36.0519 51.0929C36.5833 50.9891 37.1341 51.0418 37.6337 51.2429L43.1311 53.4584C44.5236 54.0197 45.1829 55.5853 44.6046 56.9559L44.6043 56.9567Z",
    fill: "url(#paint17_linear_106_68814)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3602 38.1483L32.5466 36.1708C31.1282 35.5881 29.5012 36.2397 28.9155 37.6281L26.6135 43.0846C26.4048 43.5792 26.3506 44.1233 26.4576 44.6491L27.288 48.7344C27.4699 49.6267 28.0963 50.3707 28.9577 50.7167L29.4373 50.9094C30.2973 51.2548 31.2764 51.1567 32.0456 50.6483L35.557 48.3292C36.0079 48.0318 36.3582 47.6109 36.5656 47.1192L38.8539 41.6953C39.4362 40.3151 38.7684 38.7285 37.3599 38.1491L37.3602 38.1483Z",
    fill: "url(#paint18_linear_106_68814)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6823 70.5689L18.8294 68.6846C17.3994 68.1293 16.7124 66.5529 17.2982 65.1645L19.6002 59.7081C19.8089 59.2134 20.1633 58.789 20.6189 58.4884L24.1596 56.1495C24.9334 55.6386 25.916 55.5384 26.7787 55.8815L27.2589 56.0727C28.1201 56.4151 28.7459 57.1545 28.926 58.0426L29.7499 62.0938C29.8558 62.6138 29.8013 63.1526 29.5938 63.6442L27.3056 69.0681C26.7233 70.4484 25.1024 71.1209 23.682 70.5696L23.6823 70.5689Z",
    fill: "url(#paint19_linear_106_68814)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3019 44.297L10.2932 49.0582C9.70342 50.4562 10.3994 52.0547 11.8456 52.6273L17.506 54.8697C18.0172 55.0723 18.5781 55.124 19.1195 55.0192L23.3216 54.2014C24.2386 54.023 25.0029 53.4105 25.3578 52.5693L25.5556 52.1006C25.9104 51.2594 25.809 50.3007 25.2853 49.5468L22.886 46.0914C22.5774 45.6463 22.1402 45.2996 21.6302 45.0941L15.9835 42.8191C14.541 42.2376 12.8917 42.899 12.3019 44.297Z",
    fill: "url(#paint20_linear_106_68814)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5745 57.6461L43.6052 62.314C43.027 63.6846 41.4282 64.3481 40.0314 63.7946L34.5206 61.611C34.0191 61.4125 33.5899 61.0735 33.2861 60.6357L30.9181 57.224C30.3988 56.4763 30.299 55.5218 30.6527 54.6836L30.8498 54.2164C31.2034 53.3782 31.9635 52.7673 32.873 52.5902L37.0214 51.782C37.5535 51.6785 38.1036 51.7309 38.6039 51.9323L44.1013 54.1478C45.4938 54.7091 46.1531 56.2747 45.5748 57.6453L45.5745 57.6461Z",
    fill: "url(#paint21_linear_106_68814)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M120.161 89.7295C115.241 101.39 120.372 114.346 131.477 118.611C142.428 122.817 155.082 116.968 159.878 105.6C164.674 94.2312 159.895 81.4162 149.066 76.9194C138.085 72.3597 125.08 78.0687 120.161 89.7295Z",
    fill: "url(#paint22_linear_106_68814)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M150.82 86.729C149.587 89.6524 146.338 91.1106 143.555 89.9827C140.763 88.8508 139.498 85.5441 140.739 82.6022C141.98 79.6604 145.251 78.2108 148.036 79.3622C150.811 80.5093 152.053 83.8064 150.82 86.7298L150.82 86.729Z",
    fill: "url(#paint23_linear_106_68814)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M139.808 112.832C138.575 115.755 135.31 117.251 132.507 116.17C129.695 115.085 128.414 111.817 129.655 108.874C130.897 105.931 134.184 104.444 136.988 105.549C139.783 106.649 141.041 109.909 139.808 112.832Z",
    fill: "url(#paint24_linear_106_68814)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M129.958 87.389C132.787 88.5312 134.066 91.8428 132.823 94.7891C131.58 97.7354 128.28 99.2179 125.441 98.0954C122.593 96.9689 121.292 93.6479 122.543 90.6816C123.795 87.7153 127.119 86.2428 129.958 87.389Z",
    fill: "url(#paint25_linear_106_68814)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M154.868 97.4408C157.608 98.5466 158.831 101.792 157.607 104.692C156.384 107.592 153.171 109.065 150.422 107.978C147.664 106.886 146.419 103.633 147.65 100.714C148.882 97.7949 152.117 96.3311 154.868 97.4408Z",
    fill: "url(#paint26_linear_106_68814)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.79 87.4174C150.557 90.3407 147.308 91.7989 144.525 90.6711C141.733 89.5392 140.468 86.2324 141.709 83.2906C142.95 80.3487 146.221 78.8991 149.006 80.0506C151.781 81.1977 153.023 84.4947 151.79 87.4181L151.79 87.4174Z",
    fill: "url(#paint27_linear_106_68814)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M140.777 113.521C139.544 116.444 136.28 117.94 133.477 116.859C130.665 115.774 129.383 112.506 130.625 109.563C131.866 106.62 135.153 105.133 137.958 106.238C140.752 107.338 142.011 110.598 140.777 113.521Z",
    fill: "url(#paint28_linear_106_68814)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130.928 88.0781C133.757 89.2195 135.036 92.5319 133.793 95.4782C132.55 98.4245 129.249 99.907 126.411 98.7845C123.563 97.658 122.262 94.337 123.513 91.3707C124.765 88.4043 128.089 86.9319 130.928 88.0781Z",
    fill: "url(#paint29_linear_106_68814)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M155.838 98.1302C158.579 99.2359 159.802 102.481 158.578 105.382C157.355 108.282 154.142 109.755 151.393 108.667C148.634 107.576 147.389 104.322 148.621 101.403C149.852 98.4843 153.088 97.0204 155.838 98.1302Z",
    fill: "url(#paint30_linear_106_68814)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M-33.4394 124.618C-30.7252 119.382 -23.0907 121.653 -18.7256 115.444C-12.7425 106.933 -23.0845 96.9706 -17.7255 87.3714C-12.4843 77.9833 1.9977 79.2904 2.66092 72.5206C2.99002 69.1582 -0.520394 68.204 -3.31616 62.1817C-7.24595 53.7158 -5.25393 44.95 -4.58662 42.4813C-0.433793 27.1196 15.8088 21.1316 18.7465 20.0482C23.7262 18.2125 28.494 17.5714 32.6899 17.5457C21.1293 13.5878 7.72628 17.2987 0.226165 27.7696L-48.2278 95.4189C-56.3312 106.733 -54.2656 121.685 -43.5077 130.266C-40.0943 132.989 -36.1699 134.744 -32.0835 135.588C-34.7961 130.096 -34.5499 126.761 -33.4394 124.618Z",
    fill: "url(#paint31_linear_106_68814)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.3,
    d: "M98.3371 78.8434C93.6776 72.928 88.39 75.4048 85.2651 70.5058C81.6217 64.7932 87.6039 59.5286 84.0988 53.4199C81.1468 48.2746 75.6171 49.7684 70.374 44.6491C69.3539 43.6535 68.3525 42.4111 67.4666 40.8432L57.2323 65.1016C55.3945 69.4578 56.9799 74.187 60.7556 75.6578L103.168 92.1727C104.06 92.5203 105 92.6333 105.935 92.5428C105.098 91.773 104.292 90.8973 103.552 89.8977C100.223 85.403 101.475 82.826 98.3378 78.8437L98.3371 78.8434Z",
    fill: "url(#paint32_linear_106_68814)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_68814",
    x1: 48.1834,
    y1: 21.5824,
    x2: 64.7279,
    y2: 195.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_68814",
    x1: 61.5703,
    y1: 54.8195,
    x2: 116.575,
    y2: 78.0253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40447E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C3B6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_68814",
    x1: 103.896,
    y1: 129.992,
    x2: 157.917,
    y2: 107.14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_68814",
    x1: 30.8406,
    y1: 78.8852,
    x2: 20.9986,
    y2: 14.5506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_68814",
    x1: 26.6825,
    y1: 87.0773,
    x2: 62.8091,
    y2: 102.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_106_68814",
    x1: 54.2991,
    y1: 63.1725,
    x2: 48.4699,
    y2: 82.5677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_106_68814",
    x1: 50.4754,
    y1: 87.9573,
    x2: 33.8927,
    y2: 117.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_106_68814",
    x1: 51.4025,
    y1: 83.8904,
    x2: 39.7855,
    y2: 110.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_106_68814",
    x1: 83.4525,
    y1: 108.369,
    x2: 116.967,
    y2: 122.508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_106_68814",
    x1: 110.878,
    y1: 80.1766,
    x2: 105.049,
    y2: 99.5718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_106_68814",
    x1: 106.577,
    y1: 108.974,
    x2: 89.9945,
    y2: 138.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_106_68814",
    x1: 107.504,
    y1: 104.907,
    x2: 95.8867,
    y2: 131.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_106_68814",
    x1: 58.5487,
    y1: 30.3296,
    x2: 57,
    y2: 53.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_106_68814",
    x1: 128.013,
    y1: 35.0485,
    x2: 126.465,
    y2: 57.8466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_106_68814",
    x1: 45.1669,
    y1: 73.95,
    x2: 41.9003,
    y2: 66.3518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_106_68814",
    x1: 30.118,
    y1: 80.4208,
    x2: 26.8514,
    y2: 72.8226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_106_68814",
    x1: 30.0854,
    y1: 80.434,
    x2: 26.8188,
    y2: 72.8358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_106_68814",
    x1: 45.0984,
    y1: 73.9797,
    x2: 41.8318,
    y2: 66.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_106_68814",
    x1: 33,
    y1: 48.8781,
    x2: 34.204,
    y2: 78.3006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_106_68814",
    x1: 22.8275,
    y1: 49.2941,
    x2: 24.0314,
    y2: 78.7165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_106_68814",
    x1: 17.8794,
    y1: 49.4962,
    x2: 19.0833,
    y2: 78.9187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_106_68814",
    x1: 37.8079,
    y1: 48.6814,
    x2: 39.0118,
    y2: 78.1039,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_106_68814",
    x1: 143.758,
    y1: 122.375,
    x2: 133.362,
    y2: 53.7709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_106_68814",
    x1: 161.459,
    y1: 123.23,
    x2: 157.128,
    y2: 112.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_106_68814",
    x1: 142.841,
    y1: 130.8,
    x2: 138.51,
    y2: 120.147,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_106_68814",
    x1: 143.114,
    y1: 130.689,
    x2: 138.782,
    y2: 120.036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_106_68814",
    x1: 161.043,
    y1: 123.399,
    x2: 156.712,
    y2: 112.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_106_68814",
    x1: 145.888,
    y1: 92.7863,
    x2: 139.867,
    y2: 144.714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_106_68814",
    x1: 137.982,
    y1: 91.8697,
    x2: 131.961,
    y2: 143.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_106_68814",
    x1: 128.954,
    y1: 90.8227,
    x2: 122.934,
    y2: 142.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_106_68814",
    x1: 154.71,
    y1: 93.8094,
    x2: 148.689,
    y2: 145.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_106_68814",
    x1: -13.7682,
    y1: 27.4673,
    x2: 2.77592,
    y2: 201.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_106_68814",
    x1: 60.7248,
    y1: 56.8232,
    x2: 115.73,
    y2: 80.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AA80F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_68814"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 211,
    height: 134.547,
    fill: "white",
    transform: "translate(-8.7002) rotate(22.8742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheoremeach);
export default __webpack_public_path__ + "static/media/theoremeach.b3c17f6479728a1bbd6c378281d4e0d3.svg";
export { ForwardRef as ReactComponent };